

// ReSharper disable InconsistentNaming
// ReSharper disable StringLiteralWrongQuotes
/* tslint:disable:no-use-before-declare quotemark max-line-length */
export interface NavViewModel {
	NavInfo: NavInfo;
	AdministeredOrganizationInfo: AdministeredOrganizationInfo;
	CurrentActiveOrganization: AdministeredOrganization;
	LogoutUrl: string;
	PersonalAccountUrl: string;
	ProductSwitcherViewModel: ProductSwitcherViewModel;
}
export interface ProductSwitcherViewModel {
	CcbTenantUrl: string;
	LaunchPadUrl: string;
	PushpayMarketingUrl: string;
}
export interface AdministeredOrganization {
	Id: number;
	Key: string;
	Name: string;
	LogoUrl: string;
	Url: string;
	IsMerchantAdmin: boolean;
	IsMasActive: boolean;
	CcbPeopleLinkingEnabled: boolean;
}
export interface AdministeredOrganizationInfo {
	Items: AdministeredOrganization[];
}
export interface NavInfo {
	OrganizationKey: string;
	IdentityKey: string;
	Profile: NavProfile;
	Header: NavHeader;
	Items: NavItem[];
	Integrations: NavIntegration[];
	Footer: NavFooter;
	CapUrl: string;
}
export interface NavFooter {
	Title: string;
	Text: string;
	Url: string;
}
export interface NavIntegration {
	Identifier: IntegrationSystemIdentifier;
	Enabled: boolean;
}
export enum IntegrationSystemIdentifier {
	FellowshipOne = 0, ChurchCommunityBuilder = 1, Elvanto = 2, ThinkMinistry = 3, PlanningCenter = 4, QuickBooks = 5, ShelbyArena = 6,
}
export interface NavItem {
	OrganizationKey: string;
	Key: NavMenuItemType;
	KeyAsString: string;
	DisplayName: string;
	Url: string;
	RoutePath: string;
	HasWarningIcon: boolean;
	WarningText: string;
	WarningUrl: string;
	Items: NavItem[];
}
export enum NavMenuItemType {
	Dashboard = 0, Transactions = 1, TransactionImportSubMenu = 2, NonCashTransactionsSubMenu = 3, Reconciliation = 4, Funds = 5, FundsSummarySubMenu = 6, ManageFundsSubMenu = 7, ReallocateSubMenu = 8, FundsImportSubMenu = 9,
	Campaigns = 10, CampaignsAddPledge = 11, PaymentRequests = 12, Community = 13, CommunityPeopleSubMenu = 14, CommunityMembersSubMenu = 15, PushpayAccountsSubMenu = 16, CommunityHouseholdsSubMenu = 17, DonorDevelopment = 18,
	DonorDevelopmentOverviewSubMenu = 19, DonorDevelopmentDonorsSubMenu = 20, Recurring = 21, RecurringMigrationSubMenu = 22, GiftEntry = 23, BatchEntrySubMenu = 24, CheckDeposit = 25, CheckDepositSubMenu = 26,
	SingleEntrySubMenu = 27, GivingStatements = 28, ResourceCenter = 29, Settings = 30, GeneralSubMenu = 31, BrandingSubMenu = 32, ServiceTimesSubMenu = 33, NotificationsSubMenu = 34, CheckScannersSubMenu = 35,
	IntegrationsSubMenu = 36, ApiSettingsSubMenu = 37, GivingSummarySubMenu = 38, CampusMappingSubMenu = 39, SandboxSettings = 40, PushpayAdmin = 41, Profile = 42, Finance = 43, FinanceOverviewSubMenu = 44,
	AppAnalytics = 45, AppAnalyticsOverviewSubMenu = 46, AppAnalyticsItemsSubMenu = 47, AppAnalyticsContainersSubMenu = 48, AppAnalyticsMessagesSubMenu = 49, PreconfiguredGivingLinkGeneratorSubMenu = 50, FinanceTransactionsSubMenu = 51,
	CAPProfile = 52,
}
export interface NavHeader {
	DisplayName: string;
	Url: string;
	LogoUrl: string;
	HelpCenterUrl: string;
}
export interface NavProfile {
	DisplayName: string;
	FirstName: string;
	LastName: string;
	Email: string;
	Url: string;
}
export interface EditCommunityMemberRequestModel {
	CommunityMemberId: number;
	FirstName: string;
	LastName: string;
	EmailAddress: string;
	MobileNumber: string;
	Address: CommunityAddressModel;
	LockVersion: number;
	CommunityMemberType: CommunityMemberType;
}
export enum CommunityMemberType {
	Unknown = 0, Individual = 1, Organization = 2,
}
export interface CommunityAddressModel {
	Line1: string;
	Line2: string;
	City: string;
	State: string;
	Postcode: string;
	Country: Country;
	DisplayAddress: string;
	PostalCodeLabel: string;
}
export interface CommunityMemberModel {
	CommunityMemberId: number;
	FirstName: string;
	LastName: string;
	EmailAddress: string;
	MobileNumber: string;
	Address: CommunityAddressModel;
	TimeZoneId: string;
	LockVersion: number;
	LastPaymentOnUtc: Date;
	LastPaymentOnLocal: Date;
	LinkedPersons: PersonModel[];
	CommunityMemberType: CommunityMemberType;
	PaymentLabel: PaymentLabel;
}
export interface PersonModel {
	PersonId: number;
	FirstName: string;
	LastName: string;
	EmailAddress: string;
	EmailAddressVerified: boolean;
	MobileNumber: string;
	MobileNumberVerified: boolean;
	Address: CommunityAddressModel;
	LastPaymentOnUtc: Date;
	LastPaymentOnLocal: Date;
	CommunityMemberType: CommunityMemberType;
}
export interface ResourceCenterViewModel {
	FiveSteps: ResourceCenterStep[];
	UserName: string;
}
export interface ResourceCenterStep {
	StepNumber: number;
	Title: string;
	Url: string;
	IsComplete: boolean;
	ImageFileName: string;
}
export interface EventTimeViewModel {
	MerchantNames: string[];
	Id: number;
	Token: string;
	Name: string;
	DayOfWeek: DayOfWeek;
	StartTime: string;
	EndTime: string;
}
export enum DayOfWeek {
	Sunday = 0, Monday = 1, Tuesday = 2, Wednesday = 3, Thursday = 4, Friday = 5, Saturday = 6,
}
export interface EventTimeEditRequest {
	Name: string;
	Id: number;
	Token: string;
	DayOfWeek: DayOfWeek;
	StartTime: string;
	EndTime: string;
}
export interface EventTimeCreateRequest {
	Name: string;
	DayOfWeek: DayOfWeek;
	StartTime: string;
	EndTime: string;
}
export interface TransactionExportButton {
	Action: ExportAction;
	Description: string;
	Label: string;
}
export enum ExportAction {
	View = 0, Csv = 1, Excel = 2, ExcelMultiMerchant = 3, Custom = 4,
}
export interface SubRegion {
	Code: string;
	Name: string;
}
export enum Country {
	NZ = 0, AU = 1, US = 2, AF = 4, AL = 8, AQ = 10, DZ = 12, AS = 16, AD = 20, AO = 24, AG = 28, AZ = 31, AR = 32, AT = 40, BS = 44, BH = 48, BD = 50, AM = 51, BB = 52, BE = 56, BM = 60, BT = 64, BO = 68,
	BA = 70, BW = 72, BV = 74, BR = 76, BZ = 84, IO = 86, SB = 90, VG = 92, BN = 96, BG = 100, MM = 104, BI = 108, BY = 112, KH = 116, CM = 120, CA = 124, CV = 132, KY = 136, CF = 140, LK = 144, TD = 148, CL = 152,
	CN = 156, TW = 158, CX = 162, CC = 166, CO = 170, KM = 174, YT = 175, CG = 178, CD = 180, CK = 184, CR = 188, HR = 191, CU = 192, CY = 196, CZ = 203, BJ = 204, DK = 208, DM = 212, DO = 214, EC = 218, SV = 222,
	GQ = 226, ET = 231, ER = 232, EE = 233, FO = 234, FK = 238, GS = 239, FJ = 242, FI = 246, AX = 248, FR = 250, GF = 254, PF = 258, TF = 260, DJ = 262, GA = 266, GE = 268, GM = 270, PS = 275, DE = 276, GH = 288,
	GI = 292, KI = 296, GR = 300, GL = 304, GD = 308, GP = 312, GU = 316, GT = 320, GN = 324, GY = 328, HT = 332, HM = 334, VA = 336, HN = 340, HK = 344, HU = 348, IS = 352, IN = 356, ID = 360, IR = 364, IQ = 368,
	IE = 372, IL = 376, IT = 380, CI = 384, JM = 388, JP = 392, KZ = 398, JO = 400, KE = 404, KP = 408, KR = 410, KW = 414, KG = 417, LA = 418, LB = 422, LS = 426, LV = 428, LR = 430, LY = 434, LI = 438, LT = 440,
	LU = 442, MO = 446, MG = 450, MW = 454, MY = 458, MV = 462, ML = 466, MT = 470, MQ = 474, MR = 478, MU = 480, MX = 484, MC = 492, MN = 496, MD = 498, ME = 499, MS = 500, MA = 504, MZ = 508, OM = 512, NA = 516,
	NR = 520, NP = 524, NL = 528, CW = 531, AW = 533, SX = 534, BQ = 535, NC = 540, VU = 548, NI = 558, NE = 562, NG = 566, NU = 570, NF = 574, NO = 578, MP = 580, UM = 581, FM = 583, MH = 584, PW = 585, PK = 586,
	PA = 591, PG = 598, PY = 600, PE = 604, PH = 608, PN = 612, PL = 616, PT = 620, GW = 624, TL = 626, PR = 630, QA = 634, RE = 638, RO = 642, RU = 643, RW = 646, BL = 652, SH = 654, KN = 659, AI = 660, LC = 662,
	MF = 663, PM = 666, VC = 670, SM = 674, ST = 678, SA = 682, SN = 686, RS = 688, SC = 690, SL = 694, SG = 702, SK = 703, VN = 704, SI = 705, SO = 706, ZA = 710, ZW = 716, ES = 724, SS = 728, SD = 729, EH = 732,
	SR = 740, SJ = 744, SZ = 748, SE = 752, CH = 756, SY = 760, TJ = 762, TH = 764, TG = 768, TK = 772, TO = 776, TT = 780, AE = 784, TN = 788, TR = 792, TM = 795, TC = 796, TV = 798, UG = 800, UA = 804, MK = 807,
	EG = 818, GB = 826, GG = 831, JE = 832, IM = 833, TZ = 834, VI = 850, BF = 854, UY = 858, UZ = 860, VE = 862, WF = 876, WS = 882, YE = 887, ZM = 894, XK = 999, __ = -2, Unsupported = -1,
}
export enum ThankYouAnimationType {
	None = 0, Hearts = 1, Confetti = 2,
}
export interface PaymentLabel {
	NounSentenceCase: string;
	NounPluralSentenceCase: string;
	VerbSentenceCase: string;
	VerbAppliedSentenceCase: string;
	NounLowerCase: string;
	NounPluralLowerCase: string;
	VerbLowerCase: string;
	VerbAppliedLowerCase: string;
	VerbPresentTenseSentenceCase: string;
	VerbPresentTenseLowerCase: string;
	VerbPastTenseSentenceCase: string;
	VerbPastTenseLowerCase: string;
	PayerSentenceCase: string;
	PayerLowerCase: string;
	PayerPluralSentenceCase: string;
	PayerPluralLowerCase: string;
	ActionSentenceCase: string;
	ActionLowerCase: string;
	ActionPluralSentenceCase: string;
	ActionPluralLowerCase: string;
	NonCashNounSentenceCase: string;
	NonCashNounLowerCase: string;
	NonCashPluralSentenceCase: string;
	NonCashPluralLowerCase: string;
	TextGivingFeatureName: string;
	GiftEntryFeatureName: string;
}
export enum FrequencyCode {
	Other = 0, Weekly = 1, Fortnightly = 2, Monthly = 3, FirstAndFifteenth = 4, OneMinute = 5, FiveMinutes = 6, FourHours = 7, Yearly = 8, SemiYearly = 9, Quarterly = 10,
}
export interface MultiSelectViewModel {
	Items: MultiSelectItem[];
	SelectedValues: string[];
}
export interface MultiSelectItem {
	Text: string;
	SelectedText: string;
	Value: string;
	Disabled: boolean;
}
export interface CommonPaymentFieldsModel {
	ReferenceFieldValues: CustomFieldEditModel[];
	GivenOn: Date;
	Notes: string;
}
export interface CustomFieldEditModel {
	Key: string;
	Type: CustomFieldType;
	Value: string;
}
export enum CustomFieldType {
	Unknown = 0, Text = 1, Number = 2, DropDown = 3, Fund = 4,
}
export interface FundCustomFieldViewModel {
	Key: string;
	Label: string;
	Placeholder: string;
	IsRequired: boolean;
	Type: CustomFieldType.Fund;
	DefaultOptionValue: string;
	Options: FundCustomFieldOptionViewModel[];
	Order: number;
}
export interface FundCustomFieldOptionViewModel {
	Label: string;
	Value: string;
	ForListing: boolean;
}
export interface DropDownCustomFieldViewModel {
	Key: string;
	Label: string;
	Placeholder: string;
	IsRequired: boolean;
	Type: CustomFieldType.DropDown;
	DefaultOptionValue: string;
	Options: DropDownCustomFieldOptionViewModel[];
	Order: number;
}
export interface DropDownCustomFieldOptionViewModel {
	Label: string;
	Value: string;
}
export interface NumberCustomFieldViewModel {
	Key: string;
	Label: string;
	Placeholder: string;
	IsRequired: boolean;
	Type: CustomFieldType.Number;
	MinLength: number;
	MaxLength: number;
	Order: number;
}
export interface TextCustomFieldViewModel {
	Key: string;
	Label: string;
	Placeholder: string;
	IsRequired: boolean;
	Type: CustomFieldType.Text;
	MinLength: number;
	MaxLength: number;
	Validation: TextFieldValidation;
	Order: number;
}
export enum TextFieldValidation {
	NoValidation = 0, LettersOnly = 1,
}
export type ICustomFieldViewModel = TextCustomFieldViewModel | NumberCustomFieldViewModel | DropDownCustomFieldViewModel | FundCustomFieldViewModel;
/* tslint:enable:no-use-before-declare quotemark max-line-length */
// ReSharper restore InconsistentNaming
// ReSharper restore StringLiteralWrongQuotes
// ReSharper disable InconsistentNaming
// ReSharper disable StringLiteralWrongQuotes
/* tslint:disable:no-use-before-declare quotemark max-line-length */
export namespace ModelMetadata {
	export class MetadataArrayOf<T> {
		metadata: T;

		constructor(metadata: T) {
			this.metadata = metadata;
		}

		at(index: number): T {
			return this.metadata;
		}
	}

	export interface IPropertyMetadata {
		propertyName: string;
		displayName?: string;
		placeholder?: string;
		validationRules?: { [rule: string]: any };
		modelMetadata?: { [name: string] :IPropertyMetadata};
	}

	export let CommonPaymentFieldsModel = {
		ReferenceFieldValues: {
			propertyName: "ReferenceFieldValues",
		},
		GivenOn: {
			propertyName: "GivenOn",
			validationRules: {
				date: {
					errorMessage: "The field GivenOn must be a date.",
				},
			},
		},
		Notes: {
			propertyName: "Notes",
			validationRules: {
				length: {
					errorMessage: "Please enter a note 255 characters or fewer",
					parameters: {
						max: 255,
					},
				},
			},
		},
	};
	export let EventTimeCreateRequest = {
		Name: {
			propertyName: "Name",
			validationRules: {
				length: {
					errorMessage: "The field Name must be a string with a maximum length of 100.",
					parameters: {
						max: 100,
					},
				},
			},
		},
		DayOfWeek: {
			propertyName: "DayOfWeek",
			validationRules: {
				required: {
					errorMessage: "The DayOfWeek field is required.",
				},
			},
		},
		StartTime: {
			propertyName: "StartTime",
			validationRules: {
				required: {
					errorMessage: "The StartTime field is required.",
				},
			},
		},
		EndTime: {
			propertyName: "EndTime",
			validationRules: {
				required: {
					errorMessage: "The EndTime field is required.",
				},
			},
		},
	};
	export let EventTimeEditRequest = {
		Name: {
			propertyName: "Name",
			displayName: "Service name",
			validationRules: {
				length: {
					errorMessage: "The field Service name must be a string with a maximum length of 100.",
					parameters: {
						max: 100,
					},
				},
				required: {
					errorMessage: "The Service name field is required.",
				},
			},
		},
		Id: {
			propertyName: "Id",
			validationRules: {
				number: {
					errorMessage: "The field Id must be a number.",
				},
				required: {
					errorMessage: "The Id field is required.",
				},
			},
		},
		Token: {
			propertyName: "Token",
			validationRules: {
				required: {
					errorMessage: "The Token field is required.",
				},
			},
		},
		DayOfWeek: {
			propertyName: "DayOfWeek",
			validationRules: {
				required: {
					errorMessage: "The DayOfWeek field is required.",
				},
			},
		},
		StartTime: {
			propertyName: "StartTime",
			validationRules: {
				required: {
					errorMessage: "The StartTime field is required.",
				},
			},
		},
		EndTime: {
			propertyName: "EndTime",
			validationRules: {
				required: {
					errorMessage: "The EndTime field is required.",
				},
			},
		},
	};
	export let EditCommunityMemberRequestModel = {
		CommunityMemberId: {
			propertyName: "CommunityMemberId",
			validationRules: {
				number: {
					errorMessage: "The field CommunityMemberId must be a number.",
				},
				required: {
					errorMessage: "The CommunityMemberId field is required.",
				},
			},
		},
		FirstName: {
			propertyName: "FirstName",
			displayName: "First name",
			validationRules: {
				length: {
					errorMessage: "The field First name must be a string with a maximum length of 100.",
					parameters: {
						max: 100,
					},
				},
				required: {
					errorMessage: "The First name field is required.",
				},
			},
		},
		LastName: {
			propertyName: "LastName",
			displayName: "Last name",
			validationRules: {
				length: {
					errorMessage: "The field Last name must be a string with a maximum length of 100.",
					parameters: {
						max: 100,
					},
				},
			},
		},
		EmailAddress: {
			propertyName: "EmailAddress",
			displayName: "Email",
			validationRules: {
				email: {
					errorMessage: "The Email field is not a valid e-mail address.",
				},
				length: {
					errorMessage: "The field Email must be a string with a maximum length of 100.",
					parameters: {
						max: 100,
					},
				},
			},
		},
		MobileNumber: {
			propertyName: "MobileNumber",
			displayName: "Mobile",
			validationRules: {
				regex: {
					errorMessage: "The Mobile field is not a valid mobile number",
					parameters: {
						pattern: "^\\+?[0-9-() ]{7,20}$",
					},
				},
			},
		},
		Address: {
			propertyName: "Address",
			displayName: "Mailing address",
			get modelMetadata() {
				return ModelMetadata.CommunityAddressModel;
			},
		},
		LockVersion: {
			propertyName: "LockVersion",
			validationRules: {
				number: {
					errorMessage: "The field LockVersion must be a number.",
				},
				range: {
					errorMessage: "The field LockVersion must be between 0 and 2147483647.",
					parameters: {
						max: 2147483647,
						min: 0,
					},
				},
				required: {
					errorMessage: "The LockVersion field is required.",
				},
			},
		},
		CommunityMemberType: {
			propertyName: "CommunityMemberType",
			validationRules: {
				required: {
					errorMessage: "The CommunityMemberType field is required.",
				},
			},
		},
	};
	export let CommunityAddressModel = {
		Line1: {
			propertyName: "Line1",
			displayName: "Address line 1",
			placeholder: "Address line 1",
			validationRules: {
				length: {
					errorMessage: "Address line 1 must be less than 100 characters",
					parameters: {
						max: 100,
					},
				},
			},
		},
		Line2: {
			propertyName: "Line2",
			displayName: "Address line 2",
			placeholder: "Address line 2",
			validationRules: {
				length: {
					errorMessage: "Address line 2 must be less than 100 characters",
					parameters: {
						max: 100,
					},
				},
			},
		},
		City: {
			propertyName: "City",
			displayName: "City",
			placeholder: "City",
			validationRules: {
				length: {
					errorMessage: "City must be less than 100 characters",
					parameters: {
						max: 100,
					},
				},
			},
		},
		State: {
			propertyName: "State",
			displayName: "State",
			placeholder: "State",
			validationRules: {
				length: {
					errorMessage: "State must be less than 100 characters",
					parameters: {
						max: 100,
					},
				},
			},
		},
		Postcode: {
			propertyName: "Postcode",
			displayName: "Zip / Postcode",
			placeholder: "Zip / Postcode",
			validationRules: {
				regex: {
					errorMessage: "Please enter a valid zip or postcode",
					parameters: {
						pattern: "^[\\w\\s-]+$",
					},
				},
			},
		},
		Country: {
			propertyName: "Country",
			displayName: "Country",
			validationRules: {
				required: {
					errorMessage: "The Country field is required.",
				},
			},
		},
		DisplayAddress: {
			propertyName: "DisplayAddress",
		},
		PostalCodeLabel: {
			propertyName: "PostalCodeLabel",
		},
	};
	export let CommunityMemberModel = {
		CommunityMemberId: {
			propertyName: "CommunityMemberId",
			validationRules: {
				number: {
					errorMessage: "The field CommunityMemberId must be a number.",
				},
				required: {
					errorMessage: "The CommunityMemberId field is required.",
				},
			},
		},
		FirstName: {
			propertyName: "FirstName",
		},
		LastName: {
			propertyName: "LastName",
		},
		EmailAddress: {
			propertyName: "EmailAddress",
		},
		MobileNumber: {
			propertyName: "MobileNumber",
		},
		Address: {
			propertyName: "Address",
			get modelMetadata() {
				return ModelMetadata.CommunityAddressModel;
			},
		},
		TimeZoneId: {
			propertyName: "TimeZoneId",
		},
		LockVersion: {
			propertyName: "LockVersion",
			validationRules: {
				number: {
					errorMessage: "The field LockVersion must be a number.",
				},
				required: {
					errorMessage: "The LockVersion field is required.",
				},
			},
		},
		LastPaymentOnUtc: {
			propertyName: "LastPaymentOnUtc",
			validationRules: {
				date: {
					errorMessage: "The field LastPaymentOnUtc must be a date.",
				},
				required: {
					errorMessage: "The LastPaymentOnUtc field is required.",
				},
			},
		},
		LastPaymentOnLocal: {
			propertyName: "LastPaymentOnLocal",
			validationRules: {
				date: {
					errorMessage: "The field LastPaymentOnLocal must be a date.",
				},
				required: {
					errorMessage: "The LastPaymentOnLocal field is required.",
				},
			},
		},
		LinkedPersons: {
			propertyName: "LinkedPersons",
		},
		CommunityMemberType: {
			propertyName: "CommunityMemberType",
			validationRules: {
				required: {
					errorMessage: "The CommunityMemberType field is required.",
				},
			},
		},
		PaymentLabel: {
			propertyName: "PaymentLabel",
		},
	};
}
/* tslint:enable:no-use-before-declare quotemark max-line-length */
// ReSharper restore InconsistentNaming
// ReSharper restore StringLiteralWrongQuotes
// ReSharper disable InconsistentNaming
// ReSharper disable StringLiteralWrongQuotes
/* tslint:disable:no-use-before-declare quotemark max-line-length */
export type CountryConfig= {
	displayName: string;
	//two-letter display code. Usually the CCA2 except when we override it, i.e. GB=>UK
	displayCode2: string;
	countryCode: Country;
	mobilePlaceholder: string;
	callingCode: string;
	subRegions: SubRegion[] | null;
};
export const CountryData: CountryConfig[] = [
{
	displayName: "Australia",
	displayCode2: "AU",
	countryCode: 1,
	mobilePlaceholder: "0412 345 678",
	callingCode: "+61",
	subRegions: [{"Code":"ACT","Name":"Australian Capital Territory"},{"Code":"NSW","Name":"New South Wales"},{"Code":"NT","Name":"Northern Territory"},{"Code":"QLD","Name":"Queensland"},{"Code":"SA","Name":"South Australia"},{"Code":"TAS","Name":"Tasmania"},{"Code":"VIC","Name":"Victoria"},{"Code":"WA","Name":"Western Australia"}],
},
{
	displayName: "Belgium",
	displayCode2: "BE",
	countryCode: 56,
	mobilePlaceholder: "0470 12 34 56",
	callingCode: "+32",
	subRegions: null,
},
{
	displayName: "Canada",
	displayCode2: "CA",
	countryCode: 124,
	mobilePlaceholder: "(201) 555-5555",
	callingCode: "+1",
	subRegions: [{"Code":"AB","Name":"Alberta"},{"Code":"BC","Name":"British Columbia"},{"Code":"MB","Name":"Manitoba"},{"Code":"NB","Name":"New Brunswick"},{"Code":"NL","Name":"Newfoundland and Labrador"},{"Code":"NT","Name":"Northwest Territories"},{"Code":"NS","Name":"Nova Scotia"},{"Code":"NU","Name":"Nunavut"},{"Code":"ON","Name":"Ontario"},{"Code":"PE","Name":"Prince Edward Island"},{"Code":"QC","Name":"Quebec"},{"Code":"SK","Name":"Saskatchewan"},{"Code":"YT","Name":"Yukon"}],
},
{
	displayName: "Switzerland",
	displayCode2: "CH",
	countryCode: 756,
	mobilePlaceholder: "078 123 45 67",
	callingCode: "+41",
	subRegions: null,
},
{
	displayName: "Germany",
	displayCode2: "DE",
	countryCode: 276,
	mobilePlaceholder: "0162 1234567",
	callingCode: "+49",
	subRegions: null,
},
{
	displayName: "Denmark",
	displayCode2: "DK",
	countryCode: 208,
	mobilePlaceholder: "20-12-34-56",
	callingCode: "+45",
	subRegions: null,
},
{
	displayName: "Finland",
	displayCode2: "FI",
	countryCode: 246,
	mobilePlaceholder: "045 71234567",
	callingCode: "+358",
	subRegions: null,
},
{
	displayName: "United Kingdom",
	displayCode2: "UK",
	countryCode: 826,
	mobilePlaceholder: "07900 123456",
	callingCode: "+44",
	subRegions: null,
},
{
	displayName: "Guatemala",
	displayCode2: "GT",
	countryCode: 320,
	mobilePlaceholder: "5123-4567",
	callingCode: "+502",
	subRegions: null,
},
{
	displayName: "Iceland",
	displayCode2: "IS",
	countryCode: 352,
	mobilePlaceholder: "678 1234",
	callingCode: "+354",
	subRegions: null,
},
{
	displayName: "Latvia",
	displayCode2: "LV",
	countryCode: 428,
	mobilePlaceholder: "23 123 456",
	callingCode: "+371",
	subRegions: null,
},
{
	displayName: "Mexico",
	displayCode2: "MX",
	countryCode: 484,
	mobilePlaceholder: "(01) 55 5555 5555",
	callingCode: "+52",
	subRegions: null,
},
{
	displayName: "Norway",
	displayCode2: "NO",
	countryCode: 578,
	mobilePlaceholder: "456 12 345",
	callingCode: "+47",
	subRegions: null,
},
{
	displayName: "New Zealand",
	displayCode2: "NZ",
	countryCode: 0,
	mobilePlaceholder: "(021) 123-4567",
	callingCode: "+64",
	subRegions: null,
},
{
	displayName: "Puerto Rico",
	displayCode2: "PR",
	countryCode: 630,
	mobilePlaceholder: "(787) 555-5555",
	callingCode: "+1787",
	subRegions: null,
},
{
	displayName: "Sweden",
	displayCode2: "SE",
	countryCode: 752,
	mobilePlaceholder: "070-123 45 67",
	callingCode: "+46",
	subRegions: null,
},
{
	displayName: "Singapore",
	displayCode2: "SG",
	countryCode: 702,
	mobilePlaceholder: "8551-2345",
	callingCode: "+65",
	subRegions: null,
},
{
	displayName: "United States of America",
	displayCode2: "US",
	countryCode: 2,
	mobilePlaceholder: "(201) 555-5555",
	callingCode: "+1",
	subRegions: [{"Code":"AL","Name":"Alabama"},{"Code":"AK","Name":"Alaska"},{"Code":"AS","Name":"American Samoa"},{"Code":"AZ","Name":"Arizona"},{"Code":"AR","Name":"Arkansas"},{"Code":"AA","Name":"Armed Forces Americas"},{"Code":"AE","Name":"Armed Forces Europe, Canada, Africa and Middle East"},{"Code":"AP","Name":"Armed Forces Pacific"},{"Code":"CA","Name":"California"},{"Code":"CO","Name":"Colorado"},{"Code":"CT","Name":"Connecticut"},{"Code":"DE","Name":"Delaware"},{"Code":"DC","Name":"District of Columbia"},{"Code":"FL","Name":"Florida"},{"Code":"GA","Name":"Georgia"},{"Code":"GU","Name":"Guam"},{"Code":"HI","Name":"Hawaii"},{"Code":"ID","Name":"Idaho"},{"Code":"IL","Name":"Illinois"},{"Code":"IN","Name":"Indiana"},{"Code":"IA","Name":"Iowa"},{"Code":"KS","Name":"Kansas"},{"Code":"KY","Name":"Kentucky"},{"Code":"LA","Name":"Louisiana"},{"Code":"ME","Name":"Maine"},{"Code":"MH","Name":"Marshall Islands"},{"Code":"MD","Name":"Maryland"},{"Code":"MA","Name":"Massachusetts"},{"Code":"MI","Name":"Michigan"},{"Code":"FM","Name":"Micronesia"},{"Code":"MN","Name":"Minnesota"},{"Code":"MS","Name":"Mississippi"},{"Code":"MO","Name":"Missouri"},{"Code":"MT","Name":"Montana"},{"Code":"NE","Name":"Nebraska"},{"Code":"NV","Name":"Nevada"},{"Code":"NH","Name":"New Hampshire"},{"Code":"NJ","Name":"New Jersey"},{"Code":"NM","Name":"New Mexico"},{"Code":"NY","Name":"New York"},{"Code":"NC","Name":"North Carolina"},{"Code":"ND","Name":"North Dakota"},{"Code":"MP","Name":"Northern Mariana Islands"},{"Code":"OH","Name":"Ohio"},{"Code":"OK","Name":"Oklahoma"},{"Code":"OR","Name":"Oregon"},{"Code":"PW","Name":"Palau"},{"Code":"PA","Name":"Pennsylvania"},{"Code":"PR","Name":"Puerto Rico"},{"Code":"RI","Name":"Rhode Island"},{"Code":"SC","Name":"South Carolina"},{"Code":"SD","Name":"South Dakota"},{"Code":"TN","Name":"Tennessee"},{"Code":"TX","Name":"Texas"},{"Code":"UT","Name":"Utah"},{"Code":"VT","Name":"Vermont"},{"Code":"VI","Name":"Virgin Islands"},{"Code":"VA","Name":"Virginia"},{"Code":"WA","Name":"Washington"},{"Code":"WV","Name":"West Virginia"},{"Code":"WI","Name":"Wisconsin"},{"Code":"WY","Name":"Wyoming"}],
},
{
	displayName: "South Africa",
	displayCode2: "ZA",
	countryCode: 710,
	mobilePlaceholder: "023 456 7890",
	callingCode: "+27",
	subRegions: null,
}];
/* tslint:enable:no-use-before-declare quotemark max-line-length */
// ReSharper restore InconsistentNaming
// ReSharper restore StringLiteralWrongQuotes
export enum DayOfWeekAbbreviated {
	Sun = 0,
	Mon = 1,
	Tue = 2,
	Wed = 3,
	Thu = 4,
	Fri = 5,
	Sat = 6,
}
// ReSharper disable InconsistentNaming
// ReSharper disable StringLiteralWrongQuotes
/* tslint:disable:no-use-before-declare quotemark max-line-length */
export type CardBrandConfig = {
	key: string;
	shortName: string;
	friendlyName: string;
	shouldLuhn: boolean;
	pattern: RegExp;
	cvvLength: number;
	cvvMask: any[];
	cvvRegex: RegExp;
	cardNumberMask: any[];
	cardNumberRegex: RegExp;
};
export const CardBrandData: CardBrandConfig[] = [
{
	key: "3",
	shortName: "Amex",
	friendlyName: "American Express",
	shouldLuhn: true,
	pattern: /^3[47]/,
	cvvLength: 4,
	cvvMask: [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/],
	cvvRegex: /^[0-9]{4}$/,
	cardNumberMask: [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/],
	cardNumberRegex: /^[0-9]{4} [0-9]{6} [0-9]{5}$/,
},
{
	key: "4",
	shortName: "Discover",
	friendlyName: "Discover",
	shouldLuhn: true,
	pattern: /^(6011|65|64[4-9]|622)/,
	cvvLength: 3,
	cvvMask: [/[0-9]/, /[0-9]/, /[0-9]/],
	cvvRegex: /^[0-9]{3}$/,
	cardNumberMask: [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/],
	cardNumberRegex: /^[0-9]{4} [0-9]{4} [0-9]{4} [0-9]{4}$/,
},
{
	key: "1",
	shortName: "MasterCard",
	friendlyName: "MasterCard",
	shouldLuhn: true,
	pattern: /^(5[0-5]|2[2-7])/,
	cvvLength: 3,
	cvvMask: [/[0-9]/, /[0-9]/, /[0-9]/],
	cvvRegex: /^[0-9]{3}$/,
	cardNumberMask: [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/],
	cardNumberRegex: /^[0-9]{4} [0-9]{4} [0-9]{4} [0-9]{4}$/,
},
{
	key: "2",
	shortName: "VISA",
	friendlyName: "Visa",
	shouldLuhn: true,
	pattern: /^4/,
	cvvLength: 3,
	cvvMask: [/[0-9]/, /[0-9]/, /[0-9]/],
	cvvRegex: /^[0-9]{3}$/,
	cardNumberMask: [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/],
	cardNumberRegex: /^[0-9]{4} [0-9]{4} [0-9]{4} [0-9]{4}$/,
},
{
	key: "0",
	shortName: "Unknown",
	friendlyName: "Default",
	shouldLuhn: false,
	pattern: /(?:)/,
	cvvLength: 3,
	cvvMask: [/[0-9]/, /[0-9]/, /[0-9]/],
	cvvRegex: /^[0-9]{3}$/,
	cardNumberMask: [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/],
	cardNumberRegex: /^[0-9]{16}$/,
}];
/* tslint:enable:no-use-before-declare quotemark max-line-length */
// ReSharper restore InconsistentNaming
// ReSharper restore StringLiteralWrongQuotes
